<div class="container">
   <ec-knr-search></ec-knr-search>
   <ec-knr-view-search></ec-knr-view-search>
  </div>
